import { Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {

  constructor(public alertController: AlertController) { }

  async launchAlert(Title, SubTitle, Message) {

    const alert = await this.alertController.create({
      header: Title,
      subHeader: SubTitle,
      message: Message,
      buttons: [
        {
          text: 'OK',
          role: 'Cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            //console.log('Confirm Cancel: blah');
          }
        }
      ]
    });

    await alert.present();
  }

  async loginSuccessAlert(Title, SubTitle, Message) {

    const alertSuccess = await this.alertController.create({
      header: Title,
      subHeader: SubTitle,
      message: Message,
      cssClass: 'custom-alert',
      buttons: [
        {
          text: 'OK',
          role: 'Cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            //console.log('Confirm Cancel: blah');
          }
        }
      ]
    });

    await alertSuccess.present();
  }

  async loginErrorAlert(Title, SubTitle, Message) {

    const alert = await this.alertController.create({
      header: Title,
      subHeader: SubTitle,
      message: Message,
      buttons: [
        {
          text: 'OK',
          role: 'Ok',
          cssClass: 'secondary',
          handler: (blah) => {
            //console.log('Confirm Ok: blah');
          }
        }
      ]
    });

    await alert.present();
  }
  

  ngOnInit() { }

}
